import { useState } from 'react';
import classNames from 'classnames';
import styles from '../../styles/FundDetailsStripedTable.module.scss';
import CustomScroll from 'components/Functional/CustomScroll';

type TableBodyRowLabels = {
  rowLabel: string;
  values: Array<string>;
}[];

type Data = {
  tableBodyRowLabels: TableBodyRowLabels;
  tableHeaderLabels: Set<string>;
};

type Props = {
  reportDate?: string;
  footnote?: string;
  wrapperId?: string;
  tableId?: string;
  isScrollable?: boolean;
  minimal?: boolean;
  data: Data;
  className: string;
};

const FundDetailsStripedTable = ({
  reportDate,
  tableId,
  data,
  isScrollable = false,
  minimal,
  wrapperId,
  footnote,
  className = '',
}: Props) => {
  const [gradientPosition, setGradientPosition] = useState('gradient-right');

  return (
    <div className={className}>
      {reportDate && <span className={styles['report-date']}>{reportDate}</span>}
      <div className="position-relative">
        <div
          id={wrapperId}
          className={classNames('mt-md-2 abrdn-table', gradientPosition, {
            scrollable: isScrollable,
          })}
        >
          <table
            id={tableId}
            className={minimal ? 'minimal' : ''}
            tabIndex={0}
            aria-label="Fund details tab table"
          >
            <thead>
              <tr>
                <th id="first_col" className="sticky-column" />
                {[...data.tableHeaderLabels].map((colName: string) => (
                  <th id={colName} key={colName}>
                    {colName}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.tableBodyRowLabels.map((item) => (
                <tr key={item.rowLabel}>
                  <th scope="row" className="sticky-column">
                    {item.rowLabel}
                  </th>
                  {item.values.map((colValue, i) => (
                    <td key={i}>{colValue}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {footnote && <div className="mt-1 footnote text-grey">{footnote}</div>}
      {isScrollable && (
        <CustomScroll
          tableId={tableId}
          wrapperId={wrapperId}
          changeGradientPosition={setGradientPosition}
        />
      )}
    </div>
  );
};

export default FundDetailsStripedTable;
